// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

/**
 * SECURITY NOTE: These are PUBLIC anon keys, not secret keys.
 *
 * The SUPABASE_PUBLISHABLE_KEY is the Supabase "anon" (anonymous) key, which is
 * designed to be used in client-side applications and exposed in the browser.
 *
 * Authentication and authorization are enforced via:
 * - Supabase Row Level Security (RLS) policies on all tables
 * - Server-side validation in Supabase Edge Functions
 *
 * This is the standard pattern for Supabase client-side applications.
 * See: https://supabase.com/docs/guides/api#api-keys
 */
const SUPABASE_URL = 'https://vpixaoxlgyowlshgumew.supabase.co';
const SUPABASE_PUBLISHABLE_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZwaXhhb3hsZ3lvd2xzaGd1bWV3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzM5Mzk3MzksImV4cCI6MjA0OTUxNTczOX0.NdcwGC62I6LaWmmm7W1TxdX6FKBUnJKMvZEdrq6pJ9s';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);
